import React, { useState } from 'react';
import $i18n from '@alife/panda-i18n';
import { icons } from '../../utils';
import './index.scss';

function LogOff({ handleLoginOff, children }) {
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const unsubscribe = async () => {
    if (!checked) return;
    setLoading(true);

    try {
      handleLoginOff && await handleLoginOff();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const openDialog = () => {
    setVisible(true);
  };

  const closeDialog = () => {
    setVisible(false);
  };

  return (
    <div className="log-off">
      <div onClick={openDialog}>{children}</div>
      {visible && (
        <div className="log-off-dialog-mask" onClick={closeDialog}>
          <div className="log-off-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="log-off-dialog-title">
              <div>
                {$i18n.get({
                  id: 'Logoff',
                  dm: '注销账号'
                })}
              </div>
              <div
                onClick={closeDialog}
                dangerouslySetInnerHTML={{
                  __html: icons.closeIcon
                }}
              />
            </div>
            <div className="log-off-dialog-content">
              <div className="tip">
                <div
                  dangerouslySetInnerHTML={{
                    __html: icons.warnIcon
                  }}
                />
                <div>
                  <div className="tip-title">
                    {$i18n.get({
                      id: 'Logoff.TipTitle',
                      dm: '菜鸟招聘官网个人账号注销须知'
                    })}
                  </div>
                  <div className="tip-content">
                    {$i18n.get({
                      id: 'Logoff.TipContent',
                      dm: '注销账号是不可逆操作，无法撤回或撤销，请您务必审慎操作'
                    })}
                  </div>
                </div>
              </div>

              <div className="log-off-dialog-text">
                <span>
                  {$i18n.get({
                    id: 'Logoff.Text',
                    dm: '您需要阅读并理解'
                  })}
                </span>
                <span
                  onClick={() => {
                    window.open('/unsubscribe-notice', '_blank');
                  }}
                >
                  {$i18n.get({
                    id: 'Logoff.ShouldKnow',
                    dm: '菜鸟招聘官网个人账号注销须知'
                  })}
                </span>
              </div>

              <div
                className="log-off-dialog-checkbox"
                onClick={() => setChecked(!checked)}
              >
                <input type="checkbox" checked={checked} />
                <span>
                  {$i18n.get({
                    id: 'Logoff.HasKnown',
                    dm: '我已阅读并理解菜鸟招聘官网个人账号注销须知'
                  })}
                </span>
              </div>

              <div
                onClick={unsubscribe}
                className={`log-off-dialog-btn ${
                  checked || loading ? '' : 'log-off-dialog-btn-disabled'
                }`}
              >
                确认注销
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LogOff;
